import * as React from "react";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import "dayjs/locale/ja";

// import { defaultDateFormat } from "app/constants";

function TimePickerInput(props) {
  const { value, setValue, disabled, className, ...otherProps } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
      <TimePicker
        value={value}
        className={className}
        onChange={(newValue) => setValue(newValue)}
        disabled={disabled}
        sx={{
          "& .MuiInputBase-input": {
            padding: "6px 16px !important",
            lineHeight: "24px !important",
            height: "24px !important",
            fontSize: "16px",
          },
          "& .Mui-disabled": {
            backgroundColor: "#f3f4f6 !important",
          },
          "& input.Mui-disabled ": {
            color: "#000 !important",
            "-webkit-text-fill-color": "#000 !important",
          },
        }}
        {...otherProps}
      />
    </LocalizationProvider>
  );
}

export default TimePickerInput;
